import { useMemo } from 'react';
import { toBool } from 'vopay';
import { AccountAndBillingHostProps } from 'shared/accountAndBilling';
import { useClientData } from '@/providers/ClientData.provider';
import { useLockedFeatures } from '@/providers/LockedFeatures.provider';
import { usePermissions } from '@/providers/Permissions.provider';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

// The one place client-dashboard maps its own user/account/permission model onto what the shared
// Account & Billing feature takes as props (ID-12900). Used where the feature is mounted (its route);
// partner-dashboard writes its own equivalent from its own providers.
export default function useBillingHostProps(): AccountAndBillingHostProps {
  const {
    response: { LoginUserName, Country, SubAccountType, ClientAccountsEnabled },
  } = useClientData();

  const {
    userSettings: { timezone },
  } = useUserSettingsProvider();

  const { CreditCardEnabled } = useLockedFeatures();

  const {
    permissions: { ManageAccountandBilling },
  } = usePermissions();

  return useMemo(
    () => ({
      viewer: { username: LoginUserName, timezone },
      account: {
        country: Country,
        isFranchise: SubAccountType === 'franchise',
        features: { creditCard: CreditCardEnabled ?? false, elinxDirectAdd: toBool(ClientAccountsEnabled) },
      },
      userPermissions: { canManageBilling: ManageAccountandBilling ?? false },
    }),
    [
      LoginUserName,
      timezone,
      Country,
      SubAccountType,
      ClientAccountsEnabled,
      CreditCardEnabled,
      ManageAccountandBilling,
    ],
  );
}
